export default __webpack_public_path__ + "static/media/logo-ecert-color.c12fa811.svg";